import CardLabel from "./TaskCard/CardLabel";
import CardStatusBadge from "./TaskCard/CardStatusBadge";
import CardAttemptsBadge from "./TaskCard/CardAttemptsBadge";
import DeleteButton from "./TaskCard/DeleteButton";
import CardIcon from "./TaskCard/CardIcon";

import { getCardVariant } from "./TaskCard/TaskCard";

const SubWorkflowTask = ({
  nodeData,
  isInconsistent,
}: {
  nodeData: any;
  isInconsistent: boolean;
}) => {
  const { task } = nodeData;
  const { type } = task;

  const subWorkflowName = task.name ? task.name : task.subWorkflowParam?.name;

  return (
    <div
      style={{
        cursor: isInconsistent ? "not-allowed" : "pointer",
        display: "flex",
        width: "100%",
        padding: "20px",
        border: "1px dashed black",
        borderRadius: "20px",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        ...getCardVariant(type, nodeData.status, nodeData.selected),
        background: "#5a8fa3d9",
      }}
    >
      {/* Execution */}
      <CardStatusBadge status={nodeData.status} />
      {nodeData?.attempts > 1 ? (
        <CardAttemptsBadge attempts={nodeData.attempts} />
      ) : null}

      {/* Definition */}
      {/* <DeleteButton maybeHideData={nodeData} /> */}

      <div
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <CardIcon type={type} />
        <div
          style={{
            paddingLeft: "6px",
            marginTop: "-2px",
            color: "white",
            textShadow: "0 1px 2px black",
          }}
        >
          {subWorkflowName}
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          top: "35px",
          left: "49px",
          color: "white",
          opacity: 0.8,
        }}
      >
        {task.taskReferenceName}
      </div>
      <CardLabel type={nodeData.task.type} />
    </div>
  );
};

export default SubWorkflowTask;
